module.exports = __webpack_public_path__ + "static/img/desc3.93ea396.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desc3.svg
// module id = Oqpl
// module chunks = 1